module.exports = __webpack_public_path__ + "assets/img/cll.fbdb0616.png";